var Markers = {};
var yourLocation;
var map;

var MapPageInit = function () {

    var initMap = function () {

        var centerLocation = locations[0];

        if (typeof google === 'undefined') {
            return;
        }

        var mapOptions = {
            mapTypeControl: false,
            zoomControl: true,
            zoom: 15,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER
            },
            disableDefaultUI: true,
            styles: [
                { elementType: 'geometry', stylers: [{ color: '#e4f1f4' }] },
                { featureType: 'administrative.locality', elementType: 'labels.text.fill', stylers: [{ color: '#3a7583' }] },

                { elementType: 'labels.text.stroke', stylers: [{ color: '#FFFFFF' }] },
                { elementType: 'labels.text.fill', stylers: [{ color: '#5e99a7' }] },

                { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#5e99a7' }] },
                { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#FFFFFF' }] },
                { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#5e99a7' }] },

                { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#FFFFFF' }] },
                { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#d8ebef' }] },
                { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#5e99a7' }] },

                { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#FFFFFF' }] },
                { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#d8ebef' }] },
                { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#5e99a7' }] },

                { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#FFFFFF' }] },
                { featureType: 'transit.station', elementType: 'labels.text.fill', stylers: [{ color: '#5e99a7' }] },

                { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#bcdbe3' }] },
                { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#5e99a7' }] },
                { featureType: 'water', elementType: 'labels.text.stroke', stylers: [{ color: '#d8ebef' }] }
            ]
        };

        map = new google.maps.Map(document.getElementById('map'), mapOptions);

        if (!locations.length) {
            return;
        }

        var markers = setMarkers(map, locations);

    }

    var setMarkers = function (map, locations) {

     
        var bounds = new google.maps.LatLngBounds();

        var infowindow = new google.maps.InfoWindow({
            maxWidth:'636'
        });

        var markers = locations.map(function (location, i) {

            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(location.lat, location.long),
                icon: '/images/site/fgsz-marker-icon.png',
                animation: google.maps.Animation.DROP,
                map: map,
                title: location.title
            });

            var content = getContent(location);
            google.maps.event.addListener(marker, 'click', (function (marker, content, infowindow) {
                return function () {
                    infowindow.setContent(content);
                    infowindow.open(map, marker);
                    map.panTo(marker.getPosition());

                };
            })(marker, content, infowindow));

            bounds.extend(marker.position);

            map.fitBounds(bounds);

            google.maps.event.addListener(map, 'click', function () {
                infowindow.close();
            });

            return marker;
        });

        return markers;
    }
    var rad = function (x) {
        return x * Math.PI / 180;
    };

    var getDistance = function (p1, p2) {
        var R = 6378137; // Earth’s mean radius in meter
        var dLat = rad(p2.lat() - p1.lat());
        var dLong = rad(p2.lng() - p1.lng());
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(rad(p1.lat())) * Math.cos(rad(p2.lat())) *
            Math.sin(dLong / 2) * Math.sin(dLong / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d; // returns the distance in meter
    };

    var getContent = function (location) {
        var yourLocationStr = "";
        if (yourLocation) {
            yourLocationStr = yourLocation.lat + ',' + yourLocation.lng;
        }

        var contentString =
            `<div  class="map-info-content">
            <p>
                ${location.title}
            </p>
            <hr/>
            <div class="lead">
                ${location.lead}
            </div>
        </div>`;

        return contentString;
    }


    var setLocation = function (position) {
        yourLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
        };
    }
    var getUrlParameter = function (sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };

    var initGeoLocation = function () {

        var query = getUrlParameter('query');

        if (typeof query === 'undefined') {
            // getDataAndsetContent('all');
        } else {
            // getDataAndsetContent(query);
        }
    };

    var getDataAndsetContent = function (query) {

        query = 'all';
        axios.post('ajax/filterPlaces', {
            params: {
                query: query,

            }
        }).then(function (response) {
            locations = response.data;
        }).catch(function (error) {
            console.log(error);
        }).then(function () {
            initMap();
        });
    };

    var initPageEvents = function () {

        $("#inputSearch").keyup(function (event) {
            if (event.keyCode === 13) {
                $('.place-filter').trigger('click');
            }
        });

        $('.place-filter').click(function (e) {
            e.preventDefault();
            var query = $("#inputSearch").val();

            if (query !== "") {
                //getDataAndsetContent(query);

                var geocoder = new google.maps.Geocoder();

                var address = query;
                geocoder.geocode({ 'address': address }, function (results, status) {
                    if (status === 'OK') {
                        initMap();
                        map.setCenter(results[0].geometry.location);
                        var marker = new google.maps.Marker({
                            map: map,
                            position: results[0].geometry.location
                        });
                        map.setZoom(12);
                    } else {
                        alert(location_not_found);
                        $('.remove-filter').trigger('click');
                    }
                });
            } else {
                $('.remove-filter').trigger('click');
            }
        });

        $('.remove-filter').click(function (e) {
            e.preventDefault();
            initMap();
        });
    }


    return {
        //main function to initiate the module
        init: function () {
            // initGeoLocation();
            initMap();
            initPageEvents();
        }
    };
}();

window.initPage = function () {
    MapPageInit.init();
}